export const candidateSearchSelector = state => state.candidateSearchInfo;